export { DescendantsVariantProvider } from './descendants-variant-provider';
